import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import styleConstants from "../../../../styleConstants";
import "./source.scss";

const useStyles = makeStyles(theme => ({
  text: {
    fill: styleConstants.colors.gray6,
    fontSize: "0.875rem",
    fontWeight: 400,
    transition: "opacity 0.3s ease-in-out",
    "&:hover": {
      cursor: "pointer"
    }
  }
}));

const DataType = props => {
  const classes = useStyles();

  return (
    <text
      id={props.id}
      className={classnames(
        classes.text,
        props.current === undefined
          ? undefined
          : props.groups.includes(props.current)
          ? "active"
          : "faded"
      )}
      onMouseEnter={props.updateCurrent}
      onMouseLeave={props.removeCurrent}
      transform={`translate(${props.tx} ${props.ty})`}
      dangerouslySetInnerHTML={{ __html: props.content }}></text>
  );
};

DataType.propTypes = {
  id: PropTypes.string.isRequired,
  tx: PropTypes.number,
  ty: PropTypes.number,
  content: PropTypes.string.isRequired
};

export default DataType;
